module.exports = __webpack_public_path__ + "static/media/SH3.04ba2fb2.png";